import { Environment } from "./environment-entity";


export const environment: Environment = new Environment({

  
  VIDEOSDK_ANALYTICS: true,
  VIDEO_CALL_MAX_DURATION: 90,

  PAYMENT_SERVICE: 'KONNECT',
  API_HOST_NAME: 'apirt.rdv247.com',
  STORAGE_ENDPOINT: 'fileuploads',
  API_URL: 'https://apirt.rdv247.com/api',
  ENV: 'development',
  DOMAINE_NAME: 'connect.rdv247.com',
  API_SSL: true,
  PORT: 0,
  addsPannels: false,
  JSP_URL:"https://cms.rdv247.com/api",
  JSP_HOST_NAME:"https://cms.rdv247.com",
  SECOND_OPINION_API_URL: 'https://second-opinion-api.rdv247.com/api',
    GOOGLE_REDIRECT_URI:"https://connect.rdv247.com/auth/callback/google"

});
